/*
Built to be applied to cardArticles and cardMedia
this sets the srcset for picture for desktop and tablet
based on the image container size.

By default srcset for large and tablet is set to be small image size
with data-srcset-large and data-srcset-tablet defined

When the image container is found to be large enough, srcset is changed
*/
var $ = require('jquery');
var Constants = require('libs/constants');
var ResponsiveUtils = require('utils/responsiveUtils');
var mobileFirstPicture = {
    changeSrcSet:function(el) {
        var _self = el || this;
        var viewport = this.getViewPort(this);
        var smallerMobileViewport = 375;
        var $srcSet = _self.$el.find('[data-srcset-'+ viewport + ']');
        // temporary var to be removed when MPO/SPO 2.0 design is in place
        var isOfferDetails = _self.$el.hasClass('m-offer-details-container');
        var srcSetValue,$picture,imgWidth,$imageSrcSet, smallerMobileParam;
        $srcSet.each(function(index,srcSet){
            $imageSrcSet = $(srcSet);
            srcSetValue = $imageSrcSet.data('srcset-' + viewport );
            $picture = $imageSrcSet.closest('picture');
            imgWidth = $picture.parent().width();
            if(imgWidth === 0 || $picture.hasClass('js-img-loaded')) {
                return;
            }
            smallerMobileParam = $picture.data('param-smaller-mobile') != undefined;
            if ( $imageSrcSet.length > 0 ) {
                /* 
                    viewport mappings
                    smallerMobileViewport: 375
                    Constants.GLOBAL.MOBILE_VIEWPORT: 600
                    Constants.GLOBAL.TABLET_VIEWPORT: 768
                    Constants.GLOBAL.DESKTOP_VIEWPORT: 1024
                */
                // additional condition for image optimization in 4 pack card presentation
                if(smallerMobileParam && imgWidth <= smallerMobileViewport ) {
                    param = $picture.data('param-smaller-mobile');

                } 
                // temporary condition to be removed when MPO/SPO 2.0 design is in place
                else if (isOfferDetails && imgWidth > smallerMobileViewport && imgWidth <= Constants.GLOBAL.MOBILE_VIEWPORT) {
                    param = $picture.data('param-tablet');

                } else if (imgWidth <= Constants.GLOBAL.MOBILE_VIEWPORT) {
                    param = $picture.data('param-mobile');

                } else if ( imgWidth > Constants.GLOBAL.MOBILE_VIEWPORT && imgWidth <= Constants.GLOBAL.TABLET_VIEWPORT ) {
                    param = $picture.data('param-tablet');

                } else if ( imgWidth > Constants.GLOBAL.TABLET_VIEWPORT && imgWidth <= Constants.GLOBAL.DESKTOP_VIEWPORT ) {
                    param = $picture.data('param-desktop');

                } else if ( imgWidth > Constants.GLOBAL.DESKTOP_VIEWPORT  ) {
                    param = $picture.data('param-large');
                }
                $picture.hasClass('mi-lazyLoadImage') && !$picture.hasClass('js-card-loaded') ? $imageSrcSet.attr( 'data-srcset', srcSetValue.replace('_queryParam_',param)) : $imageSrcSet.attr( 'srcset', srcSetValue.replace('_queryParam_',param));
                $picture.addClass('js-img-loaded');
            }
        })
        
    },
    getViewPort: function(that) {
        if (that.responsiveUtils.isMobileDevice) {
            return 'mobile';
        } else if (that.responsiveUtils.isDesktopDevice ) {
            return 'desktop';
        } else if (that.responsiveUtils.isTabletDevice) {
            return 'tablet';
        }
    },
    init:function(el) {
        var _self = this;
        console.log(this)
        _self.responsiveUtils = ResponsiveUtils.create({
            orientationChangeEventHandler: function(){_self.changeSrcSet(el)},
            resizeEventHandler: function(){_self.changeSrcSet(el)}
        });
       _self.responsiveUtils.init();
        
        this.changeSrcSet(el);
    }
}
module.exports = mobileFirstPicture;
    
    